import { createReducer } from '@reduxjs/toolkit';
import { setName } from './actions';

export default createReducer({ name: 'World' }, builder => {
    builder.addCase(setName, (state, action) => {
        state.name = action.payload;
    });
});
